(function () {
  const roots = document.querySelectorAll('[data-diagnosis-lp]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (roots.length) {
    document.documentElement.classList.add('goencha-diagnosis-page');
    if (document.body) document.body.classList.add('goencha-diagnosis-page');
  }

  roots.forEach((root) => {
    const baseUrl = root.dataset.diagnosisUrl;
    const utmSource = root.dataset.utmSource || 'diagnosis_lp';
    const utmMedium = root.dataset.utmMedium || 'cta';
    const utmCampaign = root.dataset.utmCampaign || 'goencha_diagnosis';

    const buildDiagnosisUrl = (ctaName) => {
      try {
        const url = new URL(baseUrl, window.location.origin);
        if (!url.searchParams.has('utm_source')) url.searchParams.set('utm_source', utmSource);
        if (!url.searchParams.has('utm_medium')) url.searchParams.set('utm_medium', utmMedium);
        if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', utmCampaign);
        url.searchParams.set('utm_content', ctaName || 'diagnosis_lp');
        return url.toString();
      } catch (error) {
        return baseUrl;
      }
    };

    root.querySelectorAll('.js-diagnosis-cta').forEach((link) => {
      const ctaName = link.dataset.cta || 'diagnosis_lp';
      if (baseUrl) {
        link.href = buildDiagnosisUrl(ctaName);
      }

      link.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'diagnosis_lp_cta_click',
          cta: ctaName
        });
      });
    });

    const revealTargets = root.querySelectorAll(
      '.diagnosis-lp__section, .diagnosis-lp__about-card'
    );

    let aboutCardIndex = 0;

    revealTargets.forEach((target) => {
      target.classList.add('diagnosis-lp__reveal');
      if (target.classList.contains('diagnosis-lp__about-card')) {
        target.style.transitionDelay = `${aboutCardIndex * 80}ms`;
        aboutCardIndex += 1;
      }
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach((target) => {
        target.classList.add('is-visible');
        target.style.transitionDelay = '';
      });
    } else {
      root.classList.add('diagnosis-lp--motion-ready');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12
      });

      revealTargets.forEach((target) => observer.observe(target));
    }

    root.querySelectorAll('.diagnosis-lp__faq-list details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        if (prefersReducedMotion) return;

        event.preventDefault();
        if (details.dataset.animating === 'true') return;

        const startHeight = details.offsetHeight;
        let endHeight;

        details.dataset.animating = 'true';
        details.style.overflow = 'hidden';

        if (details.open) {
          details.open = false;
          endHeight = details.offsetHeight;
          details.open = true;
        } else {
          details.open = true;
          endHeight = details.offsetHeight;
        }

        details.style.height = `${startHeight}px`;

        const animation = details.animate({
          height: [`${startHeight}px`, `${endHeight}px`]
        }, {
          duration: 240,
          easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)'
        });

        animation.onfinish = () => {
          if (startHeight > endHeight) {
            details.open = false;
          }

          details.style.height = '';
          details.style.overflow = '';
          delete details.dataset.animating;
        };

        animation.oncancel = animation.onfinish;
      });
    });
  });
})();
